import loadable from "@loadable/component";
import { inject, observer } from "mobx-react";
import React from "react";
import type { Store } from "../../../../client/stores";
import * as Webapi from "../../generated/webapi.g";
import { getContentEyebrow } from "../../lib/content";
import { getDateFormat } from "../../lib/locale";

const ContentTile = loadable(() => import("../../components/tiles/ContentTile.component"));
interface ContentFeedItemProps {
    item: Webapi.PublishRecordFragment;
    index: number;
    style: string;
    eyebrow?: Webapi.Eyebrow;
    showEyebrow: boolean;
    store?: Store;
}

const getLayout = (style: string) => {
    switch (style) {
        case "horizontal":
            return "thumb-left";
        case "horizontal-reverse":
            return "thumb-right";
        default:
            return "thumb-top";
    }
};

export const ContentFeedItem = inject("store")(
    observer(({ item, index, style, store, eyebrow, showEyebrow }: ContentFeedItemProps) => {
        if (!store) {
            return null;
        }

        const { site, microsite } = store;

        const { itemUrl, eyebrowUrl, topicName } = getContentEyebrow(site, microsite, item, eyebrow, showEyebrow);
        const eyebrowProps =
            topicName && eyebrowUrl && showEyebrow
                ? {
                      topic_name: topicName,
                      url: eyebrowUrl,
                  }
                : undefined;

        return (
            <ContentTile
                title={item.summary.title}
                url={itemUrl}
                slug={`item_${index}`}
                action="item_selected"
                thumb={item.summary.image ?? ""}
                eyebrow={eyebrowProps}
                sponsored={item.payload.is_sponsored}
                datetime={item.pub_start}
                dateFormat={getDateFormat(site)}
                layout={getLayout(style)}
                className="feed-content-item"
            />
        );
    }),
);

export default ContentFeedItem;
